import { GENDER } from '@src/shared/types/placement';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { FILTER_COLOR } from './filter-colors';

export const leadGenderFilterConfig = createSimpleFilterConfig({
  facetName: 'gender',
  color: FILTER_COLOR.blue,
  options: Object.values(GENDER).map((gender) => ({
    label: formatTextForDisplay(gender),
    value: gender,
  })),
});
